import { z } from "zod";

const DISCRIMINATOR = "isCompleted";

const zPayment = z.discriminatedUnion(DISCRIMINATOR, [
  z.object({
    [DISCRIMINATOR]: z.literal(false),
  }),
  z.object({
    [DISCRIMINATOR]: z.literal(true),
    amount: z.number().nonnegative(),
  }),
]);
type Payment = z.infer<typeof zPayment>;

export { zPayment };
export type { Payment };
